import { actionTypes } from "./timeOffActionTypes";

export const INITIAL_STATE = {
  timeOff: {},
  isError: true,
  message: "",
  employeeLeaves: [],
  weekends: [],
  annualLeaveas: 0,
  empYearLeaves: [],
  Loading: false,
  empYearLeavesLoading: false,
  empLeaves: {},
  leaveTypesCount: [],
  leaveAllowanceSummary: null,
  noDeductibleLeaveTypesInfo: null,
  annualTrends: [],
  timeOffs: null,
  pieChartData: [],
  timeOffModal: {
    StartDate: "",
    EndDate: "",
    LeaveNote: "",
    LeaveTypeId: null,
    StartingLeave: 0,
    EndingLeave: 0,
  },
  timeOffModalErrors: {
    StartDate: "",
    EndDate: "",
    LeaveNote: "",
    LeaveTypeId: "",
  },
  leaveTypes: [],
  startingLeave: [
    {
      key: 0,
      text: "Morning",
      name: "Morning",
      value: 0,
    },
    {
      key: 1,
      text: "Afternoon",
      name: "Afternoon",
      value: 1,
    },
  ],
  endingLeave: [
    {
      key: 0,
      text: "LunchTime",
      name: "LunchTime",
      value: 0,
    },
    {
      key: 1,
      text: "End of Day",
      name: "End of Day",
      value: 1,
    },
  ],
  // Validation state
  validation: {
    isLoading: false,
    result: null,
  },
  // Pagination state
  pagination: {
    currentPage: 1,
    pageSize: 50,
    totalCount: 0,
    totalPages: 0,
    hasNextPage: false,
  },
};

export default function timeOffReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.SET_EMP_LEAVES:
      return {
        ...state,
        empYearLeaves: action.payload.leaves,
        leaveTypesCount: action.payload.leaveTypesCount,
        annualLeaveas: action.payload.annualLeaveas,
        leaveAllowanceSummary: action.payload.leaveAllowanceSummary || null,
        noDeductibleLeaveTypesInfo: action.payload.noDeductibleLeaveTypesInfo ?? null,
        annualTrends: action.payload.annualTrends || [],
        timeOffs: action.payload.timeOffs || null,
        pieChartData: action.payload.pieChartData || [],
        empYearLeavesLoading: false,
      };
    case actionTypes.CLEAR_TIME_OFF_MODAL:
      return { ...state, timeOffModal: { ...INITIAL_STATE.timeOffModal } };
    case actionTypes.SHOW_ERROR:
      return { ...state, isError: action.isShow, message: action.payload };
    case actionTypes.GET_EMP_MONTH_LEAVES:
      return { ...state, employeeLeaves: action.payload, Loading: false };
    case actionTypes.APPEND_EMP_MONTH_LEAVES:
      return {
        ...state,
        employeeLeaves: [...state.employeeLeaves, ...action.payload],
        Loading: false
      };
    case actionTypes.MERGE_LEAVE_UPDATES: {
      const leaves = action.payload;
      if (!Array.isArray(leaves) || leaves.length === 0) return state;
      const firstUserId = leaves[0]?.userId ?? leaves[0]?.UserId;
      const allSameUser =
        firstUserId != null &&
        leaves.every((l) => (l.userId || l.UserId) === firstUserId);
      return {
        ...state,
        employeeLeaves: state.employeeLeaves.map((emp) => {
          const updates = leaves.filter(
            (l) => (l.userId || l.UserId) === emp.userId
          );
          if (!updates.length) return emp;
          // If backend sent the full updated list for this user (e.g. after cancel), replace entirely
          if (allSameUser && (emp.userId === firstUserId || emp.UserId === firstUserId)) {
            return { ...emp, userLeaves: updates.map((l) => ({ ...l })) };
          }
          let userLeaves = [...(emp.userLeaves || [])];
          updates.forEach((leave) => {
            const id = leave.id;
            const isCancelled =
              leave.status === 3 ||
              leave.status === "cancelled" ||
              leave.leaveRequest === null;
            if (isCancelled) {
              userLeaves = userLeaves.filter((l) => l.id !== id);
            } else {
              const idx = userLeaves.findIndex((l) => l.id === id);
              const normalized = { ...leave };
              if (idx >= 0) userLeaves[idx] = normalized;
              else userLeaves.push(normalized);
            }
          });
          return { ...emp, userLeaves };
        }),
      };
    }
    case actionTypes.SET_EMP_LEAVES_PAGINATION:
      return {
        ...state,
        pagination: action.payload
      };
    case actionTypes.LOADING:
      // Handle both action.data and action.value for backward compatibility
      const loadingValue = action.data !== undefined ? action.data : action.value;
      return { ...state, Loading: loadingValue };
    case actionTypes.EMP_YEAR_LEAVES_LOADING:
      return { ...state, empYearLeavesLoading: action.payload };
    case actionTypes.CLEAR_MONTHLY_EMP_LEAVES:
      return { ...state, employeeLeaves: [], leaveTypes: [], Loading: false };
    case actionTypes.CLEAR_YEARLY_EMP_LEAVES:
      return {
        ...state,
        empYearLeaves: [],
        weekends: [],
        leaveTypesCount: [],
        leaveTypes: [],
        leaveAllowanceSummary: null,
        noDeductibleLeaveTypesInfo: null,
        annualTrends: [],
        timeOffs: null,
        pieChartData: [],
        empYearLeavesLoading: false,
      };
    case actionTypes.FETCH_LEAVE_TYPES:
      return { ...state, leaveTypes: action.payload };
    case actionTypes.SET_VALIDATION_LOADING:
      return {
        ...state,
        validation: {
          ...state.validation,
          isLoading: action.payload,
        },
      };
    case actionTypes.SET_VALIDATION_RESULT:
      return {
        ...state,
        validation: {
          ...state.validation,
          result: action.payload,
        },
      };
    case actionTypes.CLEAR_VALIDATION_RESULT:
      return {
        ...state,
        validation: {
          ...state.validation,
          result: null,
        },
      };
    default:
      return {
        ...state,
      };
  }
}
